import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, Button, Typography, Container, Box } from '@mui/material';
import TopBar from '../components/TopBar';
import '../App.css';
import { getApiUrl } from '../apiUrl';
import { supabase, isSupabaseConfigured } from '../supabaseClient';

const API_URL = getApiUrl();

const Login = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      if (!supabase) {
        throw new Error('Supabase env vars are missing. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY in client/.env and restart npm start.');
      }
      const redirectTo = `${window.location.origin}/dashboard`;
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo }
      });
      if (error) throw error;
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert('Google login failed: ' + (error.message || 'Unknown error'));
    }
  };

  React.useEffect(() => {
    const bootstrap = async () => {
      if (!supabase) return;
      const { data } = await supabase.auth.getSession();
      if (!data?.session?.access_token) return;
      try {
        await axios.post(`${API_URL}/api/profile/bootstrap`, {}, {
          headers: { Authorization: `Bearer ${data.session.access_token}` }
        });
        navigate('/dashboard');
      } catch (_error) {
        // Keep user on login if bootstrap fails.
      }
    };
    bootstrap();
  }, [navigate]);

  return (
    <Container component="main" maxWidth="xs">
      <TopBar />
      <Card sx={{ mt: 8, p: 2 }}>
        <CardContent>
          <Typography component="h1" variant="h5">Log In</Typography>
          {!isSupabaseConfigured && (
            <Typography color="error" sx={{ mt: 1 }}>
              Supabase config missing. Set `REACT_APP_SUPABASE_URL` and `REACT_APP_SUPABASE_PUBLISHABLE_KEY` in `client/.env`, then restart the dev server.
            </Typography>
          )}
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleGoogleLogin}
              sx={{
                backgroundColor: '#4285f4',
                color: 'white',
                '&:hover': { backgroundColor: '#357ae8' },
                textTransform: 'none',
                py: 1.5,
                width: '100%'
              }}
            >
              Continue with Google
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Login;
